/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ComputeBankingTabSyncValueRequest} from '@cash-web/protos/squareup/cash/app/compute_banking_tab_sync_value.pb'
import {ComputeBankingTabSyncValueResponse} from '@cash-web/protos/squareup/cash/app/compute_banking_tab_sync_value.pb'


export const computeBankingTabSyncValue = (request: ComputeBankingTabSyncValueRequest, options?: CashRequestOptions) => post<ComputeBankingTabSyncValueRequest, ComputeBankingTabSyncValueResponse>("/2.0/cash/compute-banking-tab-sync-value", request, {...options, rejectOnError: true })